import { createContext } from 'react';

export interface TransitionContextType {
  /** Play the swirl transition without navigating (for closing modals on current page) */
  playTransition: (buttonRect?: DOMRect) => void;
  /** Navigate to a specific path with the swirl transition effect */
  navigateWithTransition: (path: string, buttonRect?: DOMRect) => void;
}

export const TransitionContext = createContext<TransitionContextType | null>(null);
